module.exports = __webpack_public_path__ + "img/mn.1e46ee4.svg";